module.exports = {
      id: "time-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#time-usage",
      toString: function () {
        return this.url;
      }
    }